<template>
  <v-dialog v-model="dialog"
            max-width="600px">
    <v-card>
      <v-toolbar
          dark
          color="primary"
      >
        <v-btn
            icon
            dark
            @click="closeDialog()"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-card-title>Убрать компенсационные баллы</v-card-title>
      </v-toolbar>
      <v-progress-linear
          color="primary"
          :indeterminate="isRemoving"
          :active="isRemoving"
      />
      <v-container>
        <v-card-subtitle v-if="type !== null && maxPoints > 0">
          <v-alert type="info" color="primary">
            Можно убрать баллов: {{ maxPoints }} шт.
          </v-alert>
        </v-card-subtitle>
        <v-card-text>
          <v-form
              ref="pointsForm"
              v-model="valid"
          >
            <v-autocomplete
                v-model="type"
                :items="types"
                outlined
                dense
                item-text="name"
                item-value="id"
                return-object
                label="Тип компенсации"
                required
            />
            <v-text-field
                v-show="type !== null"
                v-model="pointsToRemove"
                label="Введите количество баллов"
                :hint="'Максимум можно убрать ' + maxPoints + ' баллов'"
                :rules="pointsToRemoveRules"
                persistent-hint
                type="number"
                required
            />
            <v-text-field
                v-show="type !== null"
                v-model="comment"
                label="Комментарий (необязательно)"
                :disabled="maxPoints <= 0"
                persistent-hint
                required
            />
          </v-form>

        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text
              color="secondary"
              @click="closeDialog()"
          >
            Закрыть
          </v-btn>
          <v-btn
              text
              :disabled="!valid || isRemoving"
              :loading="isRemoving"
              color="primary"
              @click=removePoints()
          >
            Убрать
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import {HTTP} from "@/settings/axios";
import Settings from "@/settings/settings_url";

export default {
  name: "CompensationPointsRemove",
  data() {
    return {
      dialog: false,
      notSpentPoints: null,
      types: [],
      type: null,
      isRemoving: false,
      valid: false,
      pointsToRemove: null,
      maxPoints: null,
      pointsToRemoveRules: [
        v => !!v || 'Это поле обязательно',
        v => v > 0 || 'Введите больше 0 баллов',
        v => v <= this.maxPoints || 'Максимум можно убрать ' + this.maxPoints + ' баллов'
      ],
      comment: null,
    }
  },
  methods: {
    getTypes() {
      HTTP.get(Settings.API.URL_DEFAULT + "/compensation-type")
          .then((response) => {
            this.types = response.data
          })
    },
    getNotSpentPointsForType: async function () {
      await HTTP.get(Settings.API.URL_DEFAULT + "/compensation-points/journal"
          + "/get-added-points?studentId=" + this.student.id
          + "&compensationTypeId=" + this.type.id
          + "&halfYearId=" + this.halfYearId
          + "&yearOfStudyId=" + this.yearOfStudyId)
          .then((response) => {
            this.notSpentPoints = response.data
            this.maxPoints = this.notSpentPoints
            if(this.balance.points < this.notSpentPoints)
              this.maxPoints = this.balance.points
            else if(this.maxPoints === "")
              this.maxPoints = 0
          })
    },
    closeDialog: function() {
      this.$refs.pointsForm.reset()
      this.$refs.pointsForm.resetValidation()
      this.dialog = false
    },
    removePoints: async function() {
      this.isRemoving = true
      await this.$refs.pointsForm.validate()
      if(!this.valid)
        return

      HTTP.post(Settings.API.URL_DEFAULT + "/compensation-points-balance/remove-points", {
        "balance": this.balance,
        "compensationType": this.type,
        "points": this.pointsToRemove,
        "user": this.$store.getters.selectedUser,
        "comment": this.comment,
      })
          .then((response) => {
            this.balance = response.data
            this.$emit('updateBalance', this.balance)
            this.$emit('success', 'Баллы успешно убраны')
          })
          .catch(() => {
            this.$emit('error')
          })
          .finally(() => {
            this.closeDialog()
            this.isRemoving = false
          });
    },
  },
  watch: {
    'type': async function () {
      if (this.type === null)
        return

      await this.getNotSpentPointsForType()
    },
    'balance': async function () {
      if (this.type === null)
        return

      await this.getNotSpentPointsForType()
    }
  },
  props: {
    balance: {},
    student: {},
    halfYearId: {
      type: Number,
      default: -1
    },
    yearOfStudyId: {
      type: Number,
      default: -1
    },
  },
  created() {
    this.getTypes()
  },
}
</script>

<style scoped>

</style>